import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useStore } from 'react-redux';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, ArcElement,
  Title, Tooltip, Legend, Filler
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import materialTheme from '@Utilities/styles/materialTheme';
import { injectReducer } from 'store/reducers';
import settingsReducer from 'reducers/settings';

// Register plugins for all charts
ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement, ArcElement,
  Title, Tooltip, Legend, Filler, ChartDataLabels
);

export default function App({ children }) {
  const location = useLocation();
  const store = useStore();

  useEffect(() => {
    injectReducer(store, { key: 'settings', reducer: settingsReducer });
  }, [store]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!__DEV__) {
      ReactGA.send({
        page: window.location.pathname + window.location.search,
        hitType: 'pageview',
        title: window.location.pathname + window.location.search
      });
    }
  }, [location]);

  return (
    <ThemeProvider theme={materialTheme}>
      <div style={{ height: '100%', overflowY: 'hidden' }}>
        {children}
      </div>
    </ThemeProvider>
  );
}

App.propTypes = {
  children: PropTypes.node
};
